"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useData = void 0;
const react_redux_1 = require("react-redux");
const categories_1 = require("companion-app-components/flux/categories");
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accounts_1 = require("companion-app-components/flux/accounts");
const documentSelectors = __importStar(require("companion-app-components/flux/documents/documentsSelectors"));
const selectors_1 = require("data/datasetSharing/selectors");
const accountNodesSelectors = __importStar(require("data/accountNodes/selectors"));
const utils_1 = require("utils/utils");
const useData = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const accountNodesById = (0, react_redux_1.useSelector)((state) => accountNodesSelectors.getAccountNodesById(state));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const acNodeId = (0, utils_1.generateAcNodeId)(props.uiState.selectedAccountNodeId, props.router.location);
    const accountNode = accountNodesById.get(acNodeId);
    return {
        accountNode,
        accountNodesById,
        calendarList: featureFlags.get('calendarList'),
        projectedBalances: featureFlags.get('projectedBalances'),
        transactionCalendar: featureFlags.get('transactionCalendar'),
        hideLoanTransactions: featureFlags.get('hideLoanTransactions'),
        investmentTransactionsEnabled: featureFlags.get('investmentTransactions'),
        hideConnectedLoanTransactions: featureFlags.get('hideConnectedLoanTransactions'),
        documents: (0, react_redux_1.useSelector)((state) => documentSelectors.getDocuments(state)),
        categories: (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getCategories(state)),
        accountsById: (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state)),
        hasWriteAccess: (0, react_redux_1.useSelector)((state) => (0, selectors_1.hasDatasetWriteAccess)(state)),
        updateAccount: (data) => dispatch(accounts_1.accountsActions.updateAccount(data)),
    };
};
exports.useData = useData;
